import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-product-icon',
  templateUrl: './product-icon.component.html',
  styleUrls: ['./product-icon.component.scss']
})
export class ProductIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input()  displayColdChain:boolean=false;
  @Input() deliveryDoorStepIcon: any=false;
  @Input() showTimeIcon: any=false;
  @Input()  showGenuineProductIcon: any=false;
  @Input()  genuineProductText:any;
  @Input() deliveryTime: any;
  @Input() deliveryDoorStepText: any;
  @Input()  ColdChain: any;


  
}
